if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");

        this.hideErrors = this.dataset.hideErrors === "true";
        
        // Track if form is being processed
        this.isProcessing = false;
      }

      getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }

      getProductId() {
        // For quick view, try the quick view body first
        const quickViewBody = this.closest('.quick_view__body');
        if (quickViewBody && quickViewBody.getAttribute('data-product-id')) {
          return quickViewBody.getAttribute('data-product-id');
        }
        
        // Try multiple ways to get the product ID
        const productContainer = this.closest('[data-product-id]');
        if (productContainer) {
          return productContainer.getAttribute('data-product-id');
        }
        
        if (this.form.dataset.productId) {
          return this.form.dataset.productId;
        }
        
        const pageProductContainer = document.querySelector('[data-product-id]');
        if (pageProductContainer) {
          return pageProductContainer.getAttribute('data-product-id');
        }
        
        console.warn('Product ID not found for pre-sale popup');
        return null;
      }

      isPreSaleEnabledForCurrentLocation(productContainer) {
        if (!productContainer) {
          console.warn('Product container not found for pre-sale check');
          return false;
        }
        
        const selectedPostcode = this.getCookie('deliveryPostcode');
        if (!selectedPostcode) return false;
        
        const location = this.findPostcodeLocation(selectedPostcode);
        
        switch(location) {
          case 'Brisbane':
            return productContainer.getAttribute('data-pre-sale-brisbane') === 'true';
          case 'Melbourne':
            return productContainer.getAttribute('data-pre-sale-melbourne') === 'true';
          case 'Sydney':
            return productContainer.getAttribute('data-pre-sale-sydney') === 'true';
          case 'RestofAustralia':
            return productContainer.getAttribute('data-pre-sale-rest-australia') === 'true';
          default:
            return false;
        }
      }

      findPostcodeLocation(userSelectedPostcode) {
        if (typeof brisbanePostcodes === 'undefined') return "Unknown Location";
        
        var brisbanePostcodesArray = brisbanePostcodes.Postcodes[0].split(',');
        var melbournePostcodesArray = melbournePostcodes.Postcodes[0].split(',');
        var sydneyPostcodesArray = SydneyPostcodes.Postcodes[0].split(',');
        var restOfAustraliaPostcodesArray = RestofAustraliaPostcodes.Postcodes[0].split(',');

        function matchesPattern(pattern, postcode) {
          if (pattern.endsWith('*')) {
            let prefix = pattern.slice(0, -1);
            return postcode.startsWith(prefix);
          } else if (pattern.includes(',')) {
            return pattern.split(',').includes(postcode);
          } else {
            return pattern === postcode;
          }
        }

        let postcodeStr = userSelectedPostcode.toString();

        if (brisbanePostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
          return "Brisbane";
        } else if (melbournePostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
          return "Melbourne";
        } else if (sydneyPostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
          return "Sydney";
        } else if (restOfAustraliaPostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
          return "RestofAustralia";
        } else {
          return "Unknown Location";
        }
      }

      // CAPACITY CHECKING METHODS - MOVED INSIDE CLASS
      checkDeliveryCapacity(location, dateString) {
        // Return false if no capacity data is available
        if (typeof window.deliveryCapacitySettings === 'undefined' || !window.deliveryCapacitySettings || !window.deliveryCapacitySettings.capacityByLocation) {
          console.log('No delivery capacity data available');
          return false;
        }
        
        // Get capacity data for the location
        const locationData = window.deliveryCapacitySettings.capacityByLocation[location];
        if (!locationData || !locationData[dateString]) {
          console.log(`No capacity data for ${location} on ${dateString}`);
          return false;
        }
        
        const capacity = locationData[dateString];
        
        // 0 means unlimited capacity
        if (capacity === 0) {
          console.log(`Unlimited capacity for ${location} on ${dateString}`);
          return false;
        }
        
        // For today, check the enhanced todayCapacity data
        const today = window.deliveryCapacitySettings?.currentDate;
        if (dateString === today && window.todayCapacity && window.todayCapacity.capacityStatus) {
          const locationStatus = window.todayCapacity.capacityStatus[location];
          if (locationStatus) {
            const isReached = locationStatus.isReached;
            console.log(`Capacity check for ${location} on ${dateString}: ${locationStatus.orders}/${locationStatus.capacity} - ${isReached ? 'REACHED' : 'AVAILABLE'}`);
            return isReached;
          }
        }
        
        // For other dates, check if we have order count data in the capacityByDate structure
        if (window.deliveryCapacitySettings.capacityByDate && window.deliveryCapacitySettings.capacityByDate[dateString]) {
          const dateCapacityData = window.deliveryCapacitySettings.capacityByDate[dateString];
          
          // Check if this date has order count data
          if (dateCapacityData.orderCounts) {
            const orderCount = dateCapacityData.orderCounts[location.toLowerCase()] || 0;
            const isReached = capacity > 0 && orderCount >= capacity;
            
            console.log(`Capacity check for ${location} on ${dateString}: ${orderCount}/${capacity} - ${isReached ? 'REACHED' : 'AVAILABLE'}`);
            return isReached;
          }
        }
        
        // If we have no order count data for this date, assume available (conservative approach)
        console.log(`No order count data for ${location} on ${dateString}, assuming available`);
        return false;
      }

      checkIfDateHasCapacityData(location, dateString) {
        // Return false if no capacity settings available
        if (typeof window.deliveryCapacitySettings === 'undefined' || !window.deliveryCapacitySettings || !window.deliveryCapacitySettings.capacityByLocation) {
          console.log(`No capacity settings available for ${location} on ${dateString}`);
          return false;
        }
        
        // Get capacity data for the location
        const locationData = window.deliveryCapacitySettings.capacityByLocation[location];
        if (!locationData || !locationData[dateString]) {
          console.log(`No capacity data configured for ${location} on ${dateString}`);
          return false;
        }
        
        // If capacity is set (even if 0 for unlimited), consider it as having data
        const capacity = locationData[dateString];
        const hasData = capacity !== undefined && capacity !== null;
        
        console.log(`Capacity data check for ${location} on ${dateString}: ${hasData ? 'HAS DATA' : 'NO DATA'} (capacity: ${capacity})`);
        
        return hasData;
      }

      async fetchLiveCapacityBatch(location) {
        try {
          if (!window.deliveryAppConfig || !window.deliveryAppConfig.apiBaseUrl) {
            console.log('Live capacity API: No API configuration found, using fallback');
            return null;
          }

          const apiUrl = `${window.deliveryAppConfig.apiBaseUrl}/live-capacity?location=${encodeURIComponent(location)}`;
          console.log(`Live capacity API: Fetching data for ${location} from ${apiUrl}`);
          
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
          
          console.log(`Live capacity API: Response status: ${response.status} ${response.statusText}`);
          
          if (!response.ok) {
            const responseText = await response.text();
            console.log(`Live capacity API: Error response body: ${responseText.substring(0, 200)}...`);
            throw new Error(`API response not ok: ${response.status} ${response.statusText}`);
          }
          
          const data = await response.json();
          
          if (data.success && data.data) {
            console.log(`Live capacity API: Success for ${location}, response time: ${data.responseTime}ms`);
            return data.data;
          } else {
            throw new Error(`API returned error: ${data.error || 'Unknown error'}`);
          }
          
        } catch (error) {
          console.log('Live capacity API failed, using fallback:', error.message);
          return null; // Fallback to metafields
        }
      }

      async validateCapacityBeforeAddToCart(selectedDate, location) {
        console.log(`CRITICAL VALIDATION: Checking capacity for ${selectedDate} in ${location}`);
        
        if (!selectedDate || !location || location === "RestofAustralia") {
          return {
            isValid: true, // Allow RestofAustralia to proceed
            error: 'invalid-params',
            message: 'Invalid date or location parameters'
          };
        }
        
        let validationResult = {
          isValid: true,
          selectedDateReached: false,
          fallbackUsed: false
        };
        
        try {
          // First check if we have capacity data configured for this date/location
          const hasCapacityData = this.checkIfDateHasCapacityData(location, selectedDate);
          
          if (!hasCapacityData) {
            console.log(`📅 No capacity data configured for ${location} on ${selectedDate} - allowing order`);
            return {
              isValid: true,
              selectedDateReached: false,
              fallbackUsed: false,
              noCapacityData: true
            };
          }
          
          console.log(`📊 Capacity data exists for ${location} on ${selectedDate} - proceeding with validation`);
          
          // Try to get fresh API data (critical check for add-to-cart)
          console.log(`Fetching live capacity data for ${location}`);
          const liveData = await this.fetchLiveCapacityBatch(location);
          
          if (liveData && liveData[selectedDate]) {
            console.log(`Using live API data for validation`);
            // Use live API data for validation
            const capacity = liveData[selectedDate];
            const isAvailable = capacity.available;
            
            console.log(`Live capacity for ${selectedDate}:`, {
              available: isAvailable,
              remaining: capacity.remaining || 0,
              capacity: capacity.capacity,
              current: capacity.current
            });
            
            validationResult.selectedDateReached = !isAvailable;
          } else {
            console.log(`API failed or no data, using metafield fallback for validation`);
            validationResult.fallbackUsed = true;
            // Fallback to metafields if API fails
            const isCapacityReached = this.checkDeliveryCapacity(location, selectedDate);
            validationResult.selectedDateReached = isCapacityReached;
          }
          
          // Determine final validation result
          validationResult.isValid = !validationResult.selectedDateReached;
          
          console.log(`VALIDATION RESULT:`, {
            isValid: validationResult.isValid,
            selectedDateReached: validationResult.selectedDateReached,
            selectedDate: selectedDate,
            fallbackUsed: validationResult.fallbackUsed
          });
          
        } catch (error) {
          console.error(`Critical validation error:`, error);
          validationResult.fallbackUsed = true;
          const isCapacityReached = this.checkDeliveryCapacity(location, selectedDate);
          validationResult.selectedDateReached = isCapacityReached;
          validationResult.isValid = !validationResult.selectedDateReached;
        }
        
        return validationResult;
      }

      async validateCapacityBeforeSubmit() {
        const deliveryPostcode = this.getCookie('deliveryPostcode');
        const deliveryDateISO = this.getCookie('ISODate');
        
        if (!deliveryPostcode || !deliveryDateISO) {
          return { isValid: true }; // Let other validation handle missing data
        }
        
        const location = this.findPostcodeLocation(deliveryPostcode);
        
        // Simply extract the date part from ISO string (YYYY-MM-DD)
        const selectedDate = deliveryDateISO.split('T')[0];
        
        // Check if capacity data exists for this date/location first
        const hasCapacityData = this.checkIfDateHasCapacityData(location, selectedDate);
        
        if (!hasCapacityData) {
          console.log(`📅 No capacity restrictions for ${location} on ${selectedDate} - allowing order`);
          return { isValid: true, noCapacityData: true };
        }
        
        console.log(`📅 Capacity restrictions exist for ${location} on ${selectedDate} - validating...`);
        
        // Use the capacity validation function
        try {
          const validationResult = await this.validateCapacityBeforeAddToCart(selectedDate, location);
          return validationResult;
        } catch (error) {
          console.error('Capacity validation error:', error);
          return { isValid: true }; // Allow submission if validation fails
        }
      }

      setLoadingState(isLoading) {
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          if (isLoading) {
            submitButton.setAttribute("disabled", true);
            submitButton.classList.add("loading");
          } else {
            submitButton.removeAttribute("disabled");
            submitButton.classList.remove("loading");
          }
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        // Prevent multiple clicks - check if already processing
        if (this.isProcessing) {
          console.log('Form submission already in progress, ignoring click');
          return false;
        }

        // Set processing flag and show loading state immediately
        this.isProcessing = true;
        this.setLoadingState(true);

        try {
          // For quick view, prioritize the quick view body
          let productContainer = this.closest('.quick_view__body[data-product-id]') ||
                                this.closest('[data-product-id]') || 
                                document.querySelector('[data-product-id]');
          
          // If no data attributes found on product container, try parent column
          // Check for ANY pre-sale attribute, not just Brisbane
          if (productContainer && 
              !productContainer.getAttribute('data-pre-sale-brisbane') && 
              !productContainer.getAttribute('data-pre-sale-melbourne') && 
              !productContainer.getAttribute('data-pre-sale-sydney') && 
              !productContainer.getAttribute('data-pre-sale-rest-australia')) {
            const parentColumn = this.closest('.col[data-product-id]');
            if (parentColumn) {
              productContainer = parentColumn;
              console.log('Using parent column for pre-sale data');
            }
          }
          
          console.log('=== DEBUG: Product Form Submission ===');
          console.log('Product container found:', !!productContainer);
          console.log('Product container element:', productContainer);
          console.log('Is quick view:', !!this.closest('.quick_view__body'));
          console.log('Delivery postcode:', this.getCookie('deliveryPostcode'));
          
          if (productContainer) {
            console.log('Pre-sale attributes:', {
              'brisbane': productContainer.getAttribute('data-pre-sale-brisbane'),
              'melbourne': productContainer.getAttribute('data-pre-sale-melbourne'),
              'sydney': productContainer.getAttribute('data-pre-sale-sydney'),
              'rest-australia': productContainer.getAttribute('data-pre-sale-rest-australia')
            });
          }
          
          // Get the product ID
          const productId = this.getProductId();
          
          // Use the correct method call with 'this.' and pass productContainer
          const isPreSaleEnabledForLocation = this.isPreSaleEnabledForCurrentLocation(productContainer);
          
          console.log('Pre-sale enabled for current location:', isPreSaleEnabledForLocation);
          console.log('=== END DEBUG ===');
          
          // Get delivery data from cookies
          const deliverySuburb = this.getCookie('deliverySuburb') || '';
          const deliveryPostcode = this.getCookie('deliveryPostcode') || '';
          const deliveryDate = this.getCookie('DeliveryDate') || '';
          const deliveryDateISO = this.getCookie('ISODate') || '';

          // Handle pre-sale products (only if enabled for current location)
          if (isPreSaleEnabledForLocation) {
            console.log('Pre-sale product detected for current location in product-form component');
            
            // Check if delivery location is selected
            if (!deliverySuburb || !deliveryPostcode) {
              // Reset loading state and processing flag before opening popup
              this.setLoadingState(false);
              this.isProcessing = false;
              
              if (typeof openPopupAtStep === 'function') {
                openPopupAtStep('location');
              } else if (typeof openPopup === 'function') {
                openPopup();
                setTimeout(function() {
                  if (typeof resetToLocationStep === 'function') {
                    resetToLocationStep();
                  }
                }, 100);
              } else {
                alert('Please select your delivery suburb first.');
              }
              return false;
            }
            
            // For pre-sale products, always show date selection popup
            // Store the form reference for later submission
            window.pendingPreSaleForm = this.form;
            
            // Reset loading state and processing flag before opening popup
            this.setLoadingState(false);
            this.isProcessing = false;
            
            if (typeof openPreSalePopup === 'function') {
              openPreSalePopup(productId);
            } else if (typeof openPopupAtStep === 'function') {
              window.currentPreSaleProductId = productId;
              openPopupAtStep('date');
            } else if (typeof openPopup === 'function') {
              window.currentPreSaleProductId = productId;
              openPopup();
              setTimeout(() => {
                if (typeof popupSetupDatePickerForPreSale === 'function') {
                  popupSetupDatePickerForPreSale(deliverySuburb, this.getCookie('deliveryState'), deliveryPostcode, productId);
                } else if (typeof popupSetupDatePicker === 'function') {
                  popupSetupDatePicker(deliverySuburb, this.getCookie('deliveryState'), deliveryPostcode);
                }
              }, 100);
            }
            return false;
          }

          // Regular product logic (non-pre-sale)
          // Check if delivery information is available
          if (!deliverySuburb || !deliveryPostcode || !deliveryDate) {
            // Reset loading state and processing flag before opening popup
            this.setLoadingState(false);
            this.isProcessing = false;
            
            // Instead of alert, open the popup
            if (typeof openPopup === 'function') {
              openPopup();
              
              // If no location is selected, start from location step
              if (!deliverySuburb || !deliveryPostcode) {
                setTimeout(function() {
                  if (typeof resetToLocationStep === 'function') {
                    resetToLocationStep();
                  }
                }, 100);
              } else {
                // If location exists but no date, go to date step
                setTimeout(function() {
                  if (typeof popupSetupDatePicker === 'function') {
                    popupSetupDatePicker(deliverySuburb, this.getCookie('deliveryState'), deliveryPostcode);
                  }
                }, 100);
              }
            } else {
              // Fallback to alert if popup function doesn't exist
              alert('Please select your delivery suburb and date before adding to cart.');
            }
            
            return false;
          }

          // CAPACITY VALIDATION - Loading state continues during API call
          console.log('🔍 Starting capacity validation...');
          const capacityValidation = await this.validateCapacityBeforeSubmit();
          
          if (!capacityValidation.isValid) {
            console.log('❌ Capacity reached for selected date, refreshing page');
            
            // Show capacity reached banner if available
            if (typeof window.showCapacityReachedBanner === 'function') {
              window.showCapacityReachedBanner();
              
              // Wait 2 seconds then refresh
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            } else {
              // Immediate refresh if banner function not available
              window.location.reload();
            }
            
            // Note: We don't reset loading state here as page will refresh
            return false;
          }
          
          console.log('✅ Capacity validation passed, proceeding to cart...');
          // Loading state continues as we proceed to submitForm
          this.submitForm();
          
        } catch (error) {
          console.error('Error during form submission:', error);
          // Reset state on error
          this.setLoadingState(false);
          this.isProcessing = false;
        }
      }

      submitForm() {
        // Get delivery data from cookies
        const deliverySuburb = this.getCookie('deliverySuburb') || '';
        const deliveryPostcode = this.getCookie('deliveryPostcode') || '';
        
        // Check if this is a pre-sale submission
        const isPreSaleSubmission = window.pendingPreSaleForm === this.form || window.currentPreSaleProductId;
        
        if (!isPreSaleSubmission) {
          // Double-check capacity for regular products before final submission
          const deliveryDateISO = this.getCookie('ISODate');
          if (deliveryPostcode && deliveryDateISO) {
            const location = this.findPostcodeLocation(deliveryPostcode);
            
            // Simply extract the date part from ISO string
            const selectedDate = deliveryDateISO.split('T')[0];
            
            // Only check capacity if data exists for this date/location
            const hasCapacityData = this.checkIfDateHasCapacityData(location, selectedDate);
            
            if (hasCapacityData) {
              console.log(`🔄 Final capacity check: ${selectedDate} (extracted from ISO: ${deliveryDateISO})`);
              
              // Use the class method instead of window function
              const isCapacityReached = this.checkDeliveryCapacity(location, selectedDate);
              if (isCapacityReached) {
                console.log('❌ Final capacity check failed, refreshing page');
                window.location.reload();
                return;
              }
            } else {
              console.log(`📅 No capacity restrictions for ${location} on ${selectedDate} - proceeding with order`);
            }
          }
        }

        let deliveryDate = '';
        let deliveryDateISO = '';
        
        if (!isPreSaleSubmission) {
            // For regular products, get date from cookies
            deliveryDate = this.getCookie('DeliveryDate') || '';
            deliveryDateISO = this.getCookie('ISODate') || '';
        } else {
            // For pre-sale products, get date from form inputs (already set by popup)
            const existingDateInput = this.form.querySelector('input[name="properties[Delivery Date]"]');
            const existingDateISOInput = this.form.querySelector('input[name="properties[_ISODate]"]');
            
            deliveryDate = existingDateInput ? existingDateInput.value : '';
            deliveryDateISO = existingDateISOInput ? existingDateISOInput.value : '';
            
            console.log('Pre-sale form submission with date:', deliveryDate, 'ISO:', deliveryDateISO);
        }

        // Update or create hidden inputs for delivery properties IN THE CORRECT ORDER
        let suburbInput = this.form.querySelector('input[name="properties[Suburb]"]');
        let postcodeInput = this.form.querySelector('input[name="properties[Postcode]"]');
        let dateInput = this.form.querySelector('input[name="properties[Delivery Date]"]');
        let dateISOInput = this.form.querySelector('input[name="properties[_ISODate]"]');

        // Create inputs in order: Suburb, Postcode, Date, ISO Date
        if (!suburbInput) {
            suburbInput = document.createElement('input');
            suburbInput.type = 'hidden';
            suburbInput.name = 'properties[Suburb]';
            suburbInput.classList.add('delivery-suburb-property');
            this.form.appendChild(suburbInput);
        }
        if (!postcodeInput) {
            postcodeInput = document.createElement('input');
            postcodeInput.type = 'hidden';
            postcodeInput.name = 'properties[Postcode]';
            postcodeInput.classList.add('delivery-postcode-property');
            this.form.appendChild(postcodeInput);
        }
        if (!dateInput) {
            dateInput = document.createElement('input');
            dateInput.type = 'hidden';
            dateInput.name = 'properties[Delivery Date]';
            dateInput.classList.add('delivery-date-property');
            this.form.appendChild(dateInput);
        }
        if (!dateISOInput) {
            dateISOInput = document.createElement('input');
            dateISOInput.type = 'hidden';
            dateISOInput.name = 'properties[_ISODate]';
            dateISOInput.classList.add('delivery-date-iso-property');
            this.form.appendChild(dateISOInput);
        }

        // Set values
        suburbInput.value = deliverySuburb;
        postcodeInput.value = deliveryPostcode;
        dateInput.value = deliveryDate;
        dateISOInput.value = deliveryDateISO;

        // Note: Loading state is already set from onSubmitHandler, no need to set it again
        
        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);
        if (this.cartNotification) {
            formData.append(
                "sections",
                this.cartNotification
                    .getSectionsToRender()
                    .map((section) => section.id)
            );
            this.cartNotification.setActiveElement(document.activeElement);
        }

        if (this.cartItems) {
            formData.append(
                "sections",
                this.cartItems
                    .getSectionsToRender()
                    .map((section) => section.section)
            );
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((parsedState) => {
                if (parsedState.status) {
                    this.handleErrorMessage(parsedState.description);
                    return;
                }
                if (this.cartNotification) {
                    this.cartNotification.renderContents(parsedState);
                }

                if (this.cartItems) {
                    this.cartItems.renderContents(parsedState);
                }

                document
                    .querySelector(".product-form__error-message-wrapper")
                    ?.classList.add("no-js-inline");
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                // Reset loading state and processing flag
                this.setLoadingState(false);
                this.isProcessing = false;
                
                // Clear pre-sale state after successful submission
                if (isPreSaleSubmission) {
                    window.pendingPreSaleForm = null;
                    window.currentPreSaleProductId = null;
                }
                
                // Close quick view modal if it exists
                if (this.quickViewWarpper?.classList.contains("show__modal")) {
                    const isMobileOrTablet = window.innerWidth <= 1024;
                    
                    if (isMobileOrTablet) {
                        this.quickViewWarpper.classList.add("closing");
                        setTimeout(() => {
                            this.quickViewWarpper.classList.remove("show__modal", "closing");
                            // Important: Remove modal-open class after animation completes
                            document.body.classList.remove("modal-open");
                        }, 550);
                    } else {
                        this.quickViewWarpper.classList.remove("show__modal");
                        document.body.classList.remove("modal-open");
                    }
                }
                
                // Ensure body scroll is enabled (failsafe)
                document.body.classList.remove("modal-open");
            });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}

// Make the validation function globally available for other parts of the app
if (typeof window !== 'undefined') {
  window.validateCapacityBeforeAddToCart = async function(selectedDate, location) {
    // This is a global fallback - the main validation happens in the class
    console.log('Using global capacity validation fallback');
    return { isValid: true }; // Allow by default if class method isn't available
  };
}